import panomobiLogo from "@/assets/panomobi.png";
import enlargeLogo from "@/assets/enlarge.png";

/** 按构建环境切换品牌展示 */
const apiBase = process.env.VUE_APP_API_BASE || "https://api.panomobi.com/api";
const isEnlarge = apiBase.includes("enlargebusiness");

export const brand = {
  /** 品牌名：PanoMobi / ENLARGE */
  name: isEnlarge ? "ENLARGE" : "PanoMobi",
  /** 品牌 logo */
  logo: isEnlarge ? enlargeLogo : panomobiLogo,
  /** 是否展示 logo 图标 */
  showLogo: true,
  apiBase,
  isEnlarge,
};

export default brand;
